<template>
  <div>
    <div class="box-header">Internal Notes</div>
    <div class="content">
      <div v-if="notes" class="legacy-note">
        {{ notes }}
      </div>

      <ul v-if="adminNotes && adminNotes.length" class="note-list">
        <li v-for="note in adminNotes" :key="note.id" class="note-item">
          <div class="note-meta">
            <i class="mdi mdi-account-circle-outline"></i>
            <strong>{{ note.createdByName }}</strong>
            <span>·</span>
            <span>{{ note.createdAt | dateWithHours }}</span>
          </div>
          <div class="note-message">{{ note.message }}</div>
        </li>
      </ul>

      <div
        v-if="!notes && (!adminNotes || !adminNotes.length) && !showNotesForm"
        class="empty-state"
      >
        <i class="mdi mdi-note-text-outline"></i>
        <p>No internal notes yet</p>
      </div>

      <div v-if="showNotesForm" class="note-form">
        <textarea
          ref="noteInput"
          class="regular full bordered"
          name="name"
          rows="4"
          placeholder="Write an internal note (not visible to the customer)"
          v-model="newNote"
        />
        <div class="form-actions">
          <button
            v-if="!loading"
            type="button"
            class="form-btn"
            @click="revertChanges()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="form-btn is-primary"
            :disabled="loading || !newNote.trim()"
            @click="saveChanges()"
          >
            <i
              class="mdi"
              :class="loading ? 'mdi-loading mdi-spin' : 'mdi-check'"
            ></i>
            {{ loading ? "Saving..." : "Add note" }}
          </button>
        </div>
      </div>
      <div v-else class="form-actions">
        <button type="button" class="form-btn is-primary" @click="openForm">
          <i class="mdi mdi-plus"></i>
          Add note
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { addNoteToOrder } from "@/api/store/OrdersService.js";

export default {
  name: "Notes",
  props: {
    notes: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    orderNumber: {
      type: String,
      required: true
    },
    editing: {
      type: String,
      required: true
    },
    adminNotes: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      edit: false,
      newNote: "",
      loading: false,
      showNotesForm: false
    };
  },
  methods: {
    openForm() {
      this.showNotesForm = true;
      this.$nextTick(() => {
        if (this.$refs.noteInput) this.$refs.noteInput.focus();
      });
    },
    startEditing() {
      this.newNote = this.notes;
      this.edit = true;
    },
    revertChanges() {
      // Antes solo avisaba al padre y el formulario quedaba abierto
      this.edit = false;
      this.showNotesForm = false;
      this.newNote = "";
      this.$emit("finishedEditing", false);
    },
    saveChanges() {
      if (!this.loading && this.newNote.trim()) {
        this.loading = true;
        addNoteToOrder(this.orderNumber, this.newNote)
          .then(() => {
            this.$emit("finishedEditing", true);
          })
          .catch(() => {
            console.log("error updating order");
            this.$toast.open({
              message: "Error adding note",
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.legacy-note {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f9fafb;
  font-size: 16px;
  color: #111827;
  white-space: pre-line;
}

.note-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

.note-item {
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #126e6a;
  border-radius: 10px;
  background: white;
}

.note-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #6b7280;

  i {
    font-size: 16px;
  }

  strong {
    font-weight: 600;
    color: #374151;
  }
}

.note-message {
  font-size: 16px;
  line-height: 1.45;
  color: #111827;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 1.5rem 1rem;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.note-form textarea {
  width: 100%;
  resize: vertical;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.form-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 16px;
  font-weight: 500;
  color: #374151;

  i {
    font-size: 18px;
  }

  &:hover:not(:disabled) {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &.is-primary {
    border-color: #126e6a;
    background: #126e6a;
    color: white;

    &:hover:not(:disabled) {
      filter: brightness(1.1);
    }
  }
}
</style>
